export const contentTableConfig = {
  title: '核心数据列表',
  isAuto: false,
  propList: [
    { prop: 'empName', label: '业务员姓名', minWidth: '120', slotName: 'empName' },
    { prop: 'deptName', label: '组别', minWidth: '100', sortable: 'custom' },
    { prop: 'callDuration', label: '通话时长', minWidth: '120', sortable: 'custom', slotName: 'callDuration' },
    { prop: 'callCount', label: '通话次数', minWidth: '100', sortable: 'custom' },
    { prop: 'liveData', label: '直播数据', minWidth: '100', sortable: 'custom' },
    { prop: 'peiyangFbData', label: '培养课录播数据', minWidth: '140', sortable: 'custom' },
    { prop: 'yingxiaoFbData', label: '营销课录播数据', minWidth: '140', sortable: 'custom' },
    { prop: 'monthPerformanceAmount', label: '成交金额', minWidth: '140', sortable: 'custom' },
    { prop: 'monthPerformanceCount', label: '成交单数', minWidth: '140', sortable: 'custom' }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
